<template>
  <div class="compressed-content">
    <h3 class="page-question">Was ANY amount of blockage (plaque) noted on your last ultrasound or angiogram of your leg arteries?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hasArteriesBlockage">
      <b-form-radio v-model="survey.arteryBlockages.lastLegAngiogram.hasArteriesBlockage" name="blockage" :value="true">Yes</b-form-radio>
      <b-form-radio v-model="survey.arteryBlockages.lastLegAngiogram.hasArteriesBlockage" name="blockage" :value="false">No</b-form-radio>
    </v-form-group>
    <h3 class="mb-3 page-question">How old were you when you had this angiogram completed?</h3>
    <v-form-group class="page-buttons" :validator="$v.age" label="Age">
      <b-form-input slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="survey.arteryBlockages.lastLegAngiogram.doneAtAge"
                    placeholder="18 - 90" />
    </v-form-group>
    <h3 class="mt-5 page-question">Did your test show MORE blockage than any previous ultrasound or angiogram of your leg arteries?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.isProgression">
      <b-form-radio v-model="survey.arteryBlockages.lastLegAngiogram.isProgression" name="progress" :value="true">Yes</b-form-radio>
      <b-form-radio v-model="survey.arteryBlockages.lastLegAngiogram.isProgression" name="progress" :value="false">No</b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required, between, numeric } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    validations: {
      hasArteriesBlockage: {
        required
      },
      age: {
        required,
        between: between(18, 90),
        numeric
      },
      isProgression: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      hasArteriesBlockage() { return this.survey.arteryBlockages.lastLegAngiogram.hasArteriesBlockage; },
      age() { return this.survey.arteryBlockages.lastLegAngiogram.doneAtAge; },
      isProgression() { return this.survey.arteryBlockages.lastLegAngiogram.isProgression; }
    }
  };
</script>